export default {
  select: 'Select tags...'
};
